import { useMutation } from '@tanstack/react-query';
import { addContactEmail } from '../../services/fn-api/User';

export const useAddContactEmail = () => {
  return useMutation<Record<string, unknown>, Error, Record<string, unknown>>({
    mutationFn: async (data) => {
      return addContactEmail(data);
    },
  });
};
